import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const StyledBoxContainerTitle = styled(Box)(({ theme }) => ({
  borderBottom: '2px solid',
  borderColor: theme.palette.primary.main,
}))

export const StyledBoxContainerContent = styled(Box)(({ theme }) => ({
  padding: '0.5rem 1rem 0.5rem 1rem',
  width: '100%',
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.text.primary,
}))
